import { compare } from 'compare-versions';
import { HUBSPOT_PLATFORMS, LINKEDIN_PLATFORMS, LINKEDIN_RECRUITER_PLATFORMS, PLATFORMS, SALESFORCE_PLATFORMS, } from '../../const/app';
import { API_PROXY_PLUGIN_VERSION, AUTO_OPEN_DISABLED_PLUGIN_VERSION } from '../../utils/constants';
const getPlatform = (state) => state.settings.platform || '';
/** Mirrors MST SettingsViews.isSalesforcePlatform. */
export const selectIsSalesforcePlatform = (state) => SALESFORCE_PLATFORMS.includes(getPlatform(state));
/** Mirrors MST SettingsViews.isLinkedinPlatform. */
export const selectIsLinkedinPlatform = (state) => LINKEDIN_PLATFORMS.includes(getPlatform(state));
/** Mirrors MST SettingsViews.isHubspotPlatform. */
export const selectIsHubspotPlatform = (state) => HUBSPOT_PLATFORMS.includes(getPlatform(state));
/** Mirrors MST SettingsViews.isLinkedinRecruiter. */
export const selectIsLinkedinRecruiter = (state) => LINKEDIN_RECRUITER_PLATFORMS.includes(getPlatform(state));
/** Mirrors MST SettingsViews.isScoutPlatform. */
export const selectIsScoutPlatform = (state) => getPlatform(state) === PLATFORMS.SCOUT;
/** Auto open is disabled from core plugin 11, so the web plugin must not open the frame by itself there. */
export const selectIsAutoOpenSupported = (state) => {
    const { version } = state.settings;
    if (!version) {
        return true;
    }
    return !compare(version, AUTO_OPEN_DISABLED_PLUGIN_VERSION, '>=');
};
/** Core plugin 11.1.0+ can proxy API requests through its service worker (used when 3rd party cookies are blocked). */
export const selectIsApiProxySupported = (state) => {
    const { version } = state.settings;
    if (!version) {
        return false;
    }
    return compare(version, API_PROXY_PLUGIN_VERSION, '>=');
};
/**
 * The user's auto-open preference. `autoOpen` stays unset until the core plugin reports it,
 * so fall back to the default that applies to every user.
 */
export const selectAutoOpen = (state) => { var _a; return (_a = state.settings.autoOpen) !== null && _a !== void 0 ? _a : !!state.settings.autoOpenDefault; };
/** Auto open is both supported by the core plugin and switched on by the user. */
export const selectIsAutoOpenEnabled = (state) => selectIsAutoOpenSupported(state) && selectAutoOpen(state);
